import { render } from "./singleProduct.vue?vue&type=template&id=4ad066be&scoped=true"
import script from "./singleProduct.vue?vue&type=script&lang=js"
export * from "./singleProduct.vue?vue&type=script&lang=js"

import "./singleProduct.vue?vue&type=style&index=0&id=4ad066be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad066be"]])

export default __exports__